/*
 * @Author: xianghongai@gmail.com
 * @Date: 2017-11-18 01:11:11
 * @Last Modified by: Nicholas Hsiang
 * @Last Modified time: 2019-07-16 11:27:22
 */
(function($) {
  jQuery.fn.xBar = function(settings) {
    var config = {
      navItemCls: '.nav__item', // 触发项类名
      itemActiveCls: "nav__item_active", // 触发项激活时类名
      barCls: ".follow__bar", // bar类名
      barActiveCls: "follow__bar_active", // bar激活时类名
      activeIndex: 0, // 默认激活第 n 项
      offsetT: 0, // 距顶部的微调偏移量，如有下边框时适度向下偏移
      offsetL: 0, // 距左侧的微调偏移量
      stretchW: 0 // bar 宽度微调
    };

    if (settings) {
      jQuery.extend(config, settings);
    }
    console.log(config.offsetL);
    // 设置Bar样式
    function BarStyle($navItem, $bar) {
      var barLeft = $navItem.position().left + config.offsetL - 30;
      var barTop = config.offsetT;
      var barWidth = $navItem.width() + config.stretchW;
      $bar.css({
        'top': barTop,
        'left': barLeft,
        'width': barWidth
      });
    }

    this.each(function() {

      // 获取配置
      var navItemCls = config.navItemCls;
      var barCls = config.barCls;
      var itemActiveCls = config.itemActiveCls;
      var barActiveCls = config.barActiveCls;
      var activeIndex = config.activeIndex;

      // 获取Dom
      var $this = $(this);
      var $navItem = $this.find(navItemCls);
      var $bar = $this.find(barCls);

      // 第一次加载初始化
      if ($navItem.hasClass(itemActiveCls)) {
        activeIndex = $navItem.index($this.children('.' + itemActiveCls));
      } else {
        $navItem.eq(activeIndex).addClass(itemActiveCls);
      }

      var $itemActive = $this.children('.' + itemActiveCls);

      setTimeout(function() {
        $bar.addClass(barActiveCls);
      }, 100);

      BarStyle($itemActive, $bar);

      // 点击导航项时设置
      $navItem.on('click', function() {
        var $thisTemp = $(this);
        activeIndex = $navItem.index($thisTemp);
        $thisTemp.addClass(itemActiveCls).siblings(navItemCls).removeClass(itemActiveCls);
        BarStyle($thisTemp, $bar);
      });

      // 导航项进入和离开时设置
      $navItem.on({
        mouseenter: function() {
          var $thisTemp = $(this);
          $thisTemp.addClass(itemActiveCls).siblings(navItemCls).removeClass(itemActiveCls);
          BarStyle($thisTemp, $bar);
        },
        mouseleave: function() {
          var $thisTemp = $(this);
          $thisTemp.removeClass(itemActiveCls);
          $navItem.eq(activeIndex).addClass(itemActiveCls);
          BarStyle($navItem.eq(activeIndex), $bar);
        }
      });
    });
    return this;
  };
})(jQuery);